import { useState } from 'react'
import Table from './Table';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab2 = ({ setTaxes, taxes, detaildata, compname, salestaxId }) => {
  const [selected_item_data, setselected_item_data] = useState([]);
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid rgba(50, 50, 50, 0.35)", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Taxes and Chargess</p>
        <Table taxes={taxes} setTaxes={setTaxes} detaildata={detaildata} compname={compname} />
      </div>

      <div className="">
        <ActivityCard doctype="Purchase Taxes and Charges Template" docname={salestaxId} />
      </div>


    </div>
  )
}

export default Tab2